
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { cn } from "@/lib/utils";

export const cardColors = [
  { name: "Padrão", value: "bg-card" },
  { name: "Azul", value: "bg-blue-50" },
  { name: "Verde", value: "bg-green-50" },
  { name: "Amarelo", value: "bg-yellow-50" },
  { name: "Laranja", value: "bg-orange-50" },
  { name: "Vermelho", value: "bg-red-50" },
  { name: "Roxo", value: "bg-purple-50" },
  { name: "Rosa", value: "bg-pink-50" },
];

interface CardColorSelectorProps {
  selectedColor: string;
  onChange: (value: string) => void;
}

export const CardColorSelector = ({ selectedColor, onChange }: CardColorSelectorProps) => {
  return (
    <div className="space-y-2">
      <Label className="text-sm font-medium">Cor de Fundo</Label>
      <RadioGroup 
        value={selectedColor} 
        onValueChange={onChange}
        className="grid grid-cols-4 gap-2"
      >
        {cardColors.map((color) => (
          <div key={color.value} className="flex items-center space-x-1">
            <RadioGroupItem 
              value={color.value} 
              id={color.value}
              className="sr-only"
            />
            <Label
              htmlFor={color.value}
              className={cn(
                "h-8 w-8 rounded-md cursor-pointer flex items-center justify-center border hover:ring-2 hover:ring-primary transition-all",
                color.value
              )}
            >
              {selectedColor === color.value && (
                <div className="w-2 h-2 rounded-full bg-primary/70" />
              )}
            </Label>
          </div>
        ))}
      </RadioGroup>
    </div>
  );
};
